/**
 * @generated SignedSource<<06730bcc3a666e89d1692a536b311c44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type nav_CelloReferralFragment_viewer_refetchCelloUserToken$variables = {};
export type nav_CelloReferralFragment_viewer_refetchCelloUserToken$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"nav_CelloReferralFragment_viewer">;
  };
};
export type nav_CelloReferralFragment_viewer_refetchCelloUserToken = {
  response: nav_CelloReferralFragment_viewer_refetchCelloUserToken$data;
  variables: nav_CelloReferralFragment_viewer_refetchCelloUserToken$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "nav_CelloReferralFragment_viewer_refetchCelloUserToken",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "nav_CelloReferralFragment_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "nav_CelloReferralFragment_viewer_refetchCelloUserToken",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "celloUserToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "877c52bc530e8143fbe5552e62740b77",
    "id": null,
    "metadata": {},
    "name": "nav_CelloReferralFragment_viewer_refetchCelloUserToken",
    "operationKind": "query",
    "text": "query nav_CelloReferralFragment_viewer_refetchCelloUserToken {\n  viewer {\n    ...nav_CelloReferralFragment_viewer\n    id\n  }\n}\n\nfragment nav_CelloReferralFragment_viewer on Viewer {\n  celloUserToken\n  user {\n    firstName\n    lastName\n    fullName\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ebde031fce6bf559db49d114356b205";

export default node;
